import { enumSort } from '@/ui/utils/sorts'
import { textSort } from '@/ui/utils/sorts'

import { FoodStockFoodItem } from '../../domain/models/FoodStockFoodItem'
import { FoodStockFoodItemCondition } from '../../domain/models/FoodStockFoodItemCondition'
import { FoodStockFoodItemStatus } from '../../domain/models/FoodStockFoodItemStatus'
import { FoodStockRepository } from '../../domain/repositories/FoodStockRepository'
import { FoodStockDatasource } from '../datasources/FoodStockDatasource'

export function foodStockRepository(
  foodDatasource: FoodStockDatasource
): FoodStockRepository {
  return {
    async createFoodStock(data) {
      return await foodDatasource.createFoodStock(data)
    },
    async createItemFoodStock(data) {
      return await foodDatasource.createItemFoodStock(data)
    },
    async updateFoodStockMinimumQuantity(stockFoodId, data) {
      return await foodDatasource.updateFoodStockMinimumQuantity(
        stockFoodId,
        data
      )
    },
    async listAllPatientsFoodStock() {
      return await foodDatasource.listAllPatientsFoodStock()
    },
    async listPatientFoodStock(patientId) {
      const patientFoodStockList =
        await foodDatasource.listPatientFoodStock(patientId)

      patientFoodStockList
        .sort(({ place: placeA }, { place: placeB }) =>
          textSort(placeA, placeB)
        )
        .map((foodStock) => {
          if (foodStock.stockFoods) {
            foodStock.stockFoods
              .sort(({ food: { name: nameA } }, { food: { name: nameB } }) =>
                textSort(nameA, nameB)
              )
              .forEach(({ items }) => {
                items.sort((itemA, itemB) => {
                  const conditionSort = enumSort<
                    FoodStockFoodItem,
                    FoodStockFoodItemCondition
                  >({
                    enumData: [
                      FoodStockFoodItemCondition.enum.SEALED,
                      FoodStockFoodItemCondition.enum.IN_USE
                    ],
                    getSortProperty(data) {
                      return data.condition
                    }
                  })(itemA, itemB)

                  const statusSort = enumSort<
                    FoodStockFoodItem,
                    FoodStockFoodItemStatus
                  >({
                    enumData: [
                      FoodStockFoodItemStatus.enum.VALID,
                      FoodStockFoodItemStatus.enum.EXPIRING_SOON,
                      FoodStockFoodItemStatus.enum.EXPIRED
                    ],
                    getSortProperty(data) {
                      return data.status
                    }
                  })(itemA, itemB)

                  return conditionSort === 0 ? statusSort : conditionSort
                })
              })
          }
          return foodStock
        })

      return patientFoodStockList
    },
    async deleteFoodStock(foodStockId) {
      return await foodDatasource.deleteFoodStock(foodStockId)
    },

    async createFoodStockFood(data) {
      return await foodDatasource.createFoodStockFood(data)
    },

    async createFoodStockFoodItem(data) {
      return await foodDatasource.createFoodStockFoodItem(data)
    },
    async deleteFoodStockFoodItem(foodStockItemId) {
      return await foodDatasource.deleteFoodStockFoodItem(foodStockItemId)
    },
    async deleteFoodStockItem(foodStockId) {
      return await foodDatasource.deleteFoodStockItem(foodStockId)
    }
  }
}
